import React from "react";

const SkeletonCard = ({ className = "" }) => {
  return (
    <div
      className={`${className} w-full bg-white rounded-[20px] px-6 pt-8 lg:pt-12 pb-10 lg:px-8 flex flex-col justify-between animate-pulse`}
    >
      <div className="flex-1">
        <div className="mb-4 h-5 w-10 bg-gray-200 rounded" />
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded w-full" />
          <div className="h-4 bg-gray-200 rounded w-11/12" />
          <div className="h-4 bg-gray-200 rounded w-10/12" />
        </div>
      </div>
      <div className="flex items-center gap-3 pt-4">
        <div className="w-10 h-10 lg:w-11 lg:h-11 rounded-full bg-gray-200" />
        <div className="flex-1 flex flex-col gap-2">
          <div className="h-4 bg-gray-200 rounded w-1/2" />
          <div className="h-3 bg-gray-200 rounded w-1/3" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;
